import React, { memo } from 'react'
import AllocationBasicChip from './AllocationBasicChip'

const UnallocatedChip = memo(({ unallocatedQuantity, loading }: { unallocatedQuantity: number; loading: boolean }) => {
  return <AllocationBasicChip loading={loading} label={`Unallocated stock (${unallocatedQuantity})`} />
})

export default UnallocatedChip
